<div class="flex flex-col relative flex-1 h-full content">
<!--    <div class="bg-opacity-40 h-[16px]"></div>-->
    @if (isLoading() && !!orderDataSelected() && false) {
        <div
            class="relative flex flex-col gap-[6px] p-5 overflow-y-auto h-full"
            scrollInverted
            (scrolledToTop)="onScrollToTop()"
            (scrollStateChange)="onScrollStateChange($event)"
        >
            <div class="max-w-[70%] w-full flex gap-2 self-start">
                <div class="w-8 flex-shrink-0 flex items-end"></div>
                <ngx-skeleton-loader class="flex-1" [theme]="{ background: '#FFFFFF', 'width.%': 100, 'height.px': 194, 'borderRadius.px': 12 }" />
            </div>
            <div class="max-w-[70%] w-full flex gap-2 self-start">
                <div class="w-8 flex-shrink-0 flex items-end">
                    <ngx-skeleton-loader [theme]="{ background: '#FFFFFF', 'width.px': 32, 'height.px': 32, 'borderRadius.px': 32 }" />
                </div>
                <ngx-skeleton-loader class="flex-1" [theme]="{ background: '#FFFFFF', 'width.%': 40, 'height.px': 31, 'borderRadius.px': 12 }" />
            </div>

            <!-- date -->
            <div class="flex justify-center items-center my-4 mx-auto">
                <ngx-skeleton-loader [theme]="{ background: '#c8d1d6', 'width.px': 130, 'height.px': 25, 'borderRadius.px': 8 }" />
            </div>

            <div class="max-w-[70%] w-full flex gap-2 self-start">
                <div class="w-8 flex-shrink-0 flex items-end">
                    <ngx-skeleton-loader [theme]="{ background: '#FFFFFF', 'width.px': 32, 'height.px': 32, 'borderRadius.px': 32 }" />
                </div>
                <ngx-skeleton-loader
                    class="flex-1"
                    [theme]="{ background: '#FFFFFF', 'max.width.%': 100, 'width.px': 298, 'height.px': 52, 'borderRadius.px': 12 }"
                />
            </div>

            <!-- my message -->
            <div class="max-w-[70%] w-full flex gap-2 self-end justify-end">
                <ngx-skeleton-loader class="flex-1" [theme]="{ background: '#158fef', 'width.%': 100, 'height.px': 194, 'borderRadius.px': 12 }" />
            </div>
            <div class="max-w-[70%] w-full flex gap-2 self-end justify-end">
                <ngx-skeleton-loader class="flex-1" [theme]="{ background: '#158fef', 'width.%': 100, 'height.px': 194, 'borderRadius.px': 12 }" />
            </div>
            <div class="max-w-[70%] w-full flex gap-2 self-end justify-end">
                <ngx-skeleton-loader
                    class="flex-1"
                    [theme]="{ background: '#158fef', 'max.width.%': 100, 'width.px': 298, 'height.px': 52, 'borderRadius.px': 12 }"
                />
            </div>
        </div>
    } @else {
        @if (isEmpty()) {
            <div class="flex justify-center items-center m-auto">
                <ng-content />
            </div>
        } @else {
            <div
                class="relative flex flex-col gap-[6px] p-5 overflow-y-auto h-full"
                scrollInverted
                (scrolledToTop)="onScrollToTop()"
                (scrollStateChange)="onScrollStateChange($event)"
            >
                @for (message of viewMessage(); track message.key) {
                    @if (message.isDate) {
                        <div class="flex justify-center items-center px-4 py-[6px] my-4 mx-auto bg-neutral-light rounded-[8px]">
                            <span class="font-semiBold text-[11px] leading-[13px] text-neutral-darker uppercase">
                                {{ message.text }}
                            </span>
                        </div>
                    } @else {
                        <div class="max-w-[70%] flex gap-2" [class.self-end]="message.myMessage" [class.self-start]="!message.myMessage">
                            @if (!message.myMessage) {
                                <div class="w-8 flex-shrink-0 flex items-end">
                                    @if (message.user.enabled) {
                                        <div class="sticky bottom-0 left-0">
                                            <ngx-avatars [src]="message.user.avatarUrl" [initialsSize]="2" [name]="message.user.name" [size]="32" />
                                        </div>
                                    }
                                </div>
                            }

                            <div class="flex flex-col relative">
                                @if (message.media) {
                                    @switch (message.media.type) {
                                        @case ('image') {
                                            <figure
                                                [class.bg-brand-main-darker]="message.myMessage"
                                                [class.bg-white]="!message.myMessage"
                                                [class.dark:bg-kiwid-surface-sunken]="!message.myMessage"
                                                [class.ml-auto]="message.myMessage"
                                                [class.mr-auto]="!message.myMessage"
                                                class="z-10 relative p-[3px] min-w-[120px] max-w-full overflow-hidden rounded-[8px] flex flex-row justify-center items-center hover:cursor-pointer"
                                                (click)="message.media.onClick()"
                                            >
                                                <img
                                                    (load)="message.media.onLoad()"
                                                    class="max-w-full rounded-[8px]"
                                                    [style]="message.media.style"
                                                    [src]="message.media.url"
                                                    [alt]="message.media.title"
                                                />

                                                <div
                                                    style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0))"
                                                    class="pt-[15px] px-[10px] pb-[5px] rounded-b-[8px] pr-[10px] text-[11px] font-medium text-right text-white leading-[160%] absolute bottom-[2px] right-[2px] left-[2px] hover:cursor-pointer"
                                                >
                                                    {{ message.hour }}
                                                </div>

                                                @if (message.media.isLoading) {
                                                    <div
                                                        (click)="$event.stopPropagation()"
                                                        class="w-full h-full absolute top-0 left-0 flex flex-row justify-center items-center hover:cursor-default"
                                                    >
                                                        <mat-spinner color="accent" diameter="25" strokeWidth="2" class="loader" />
                                                    </div>
                                                }
                                            </figure>
                                        }
                                        @case ('video') {
                                            @let isStart = false;

                                            <div
                                                [class.bg-brand-main-darker]="message.myMessage"
                                                [class.ml-auto]="message.myMessage"
                                                [class.bg-white]="!message.myMessage"
                                                [class.dark:bg-kiwid-surface-sunken]="!message.myMessage"
                                                [class.mr-auto]="!message.myMessage"
                                                class="z-10 relative p-[3px] overflow-hidden rounded-[8px] flex justify-center items-center hover:cursor-pointer"
                                                (click)="message.media.onClick()"
                                            >
                                                <video
                                                    class="relative rounded-[8px] max-h-[220px]"
                                                    [style]="message.media.style"
                                                    #video
                                                    [controls]="false"
                                                    autoplay
                                                    [muted]="true"
                                                    [loop]="true"
                                                    (loadedmetadata)="message.media.onLoadVideo(video)"
                                                >
                                                    <source [src]="message.media.url" type="video/mp4" />
                                                </video>

                                                <div
                                                    style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0))"
                                                    class="pt-[15px] px-[10px] pb-[5px] rounded-b-[8px] pr-[10px] text-[11px] font-medium flex justify-between gap-5 items-center text-white leading-[160%] absolute bottom-[2px] right-[2px] left-[2px] hover:cursor-pointer"
                                                >
                                                    <div class="flex items-center gap-1">
                                                        <mat-icon class="size-14 text-white" svgIcon="heroicons_solid:video-camera" />

                                                        @if (message.media.duration(); as duration) {
                                                            {{ duration }}
                                                        }
                                                    </div>

                                                    {{ message.hour }}
                                                </div>

                                                @if (message.media.isLoading) {
                                                    <div
                                                        (click)="$event.stopPropagation()"
                                                        class="w-full h-full absolute top-0 left-0 flex flex-row justify-center items-center hover:cursor-default"
                                                    >
                                                        <mat-spinner color="accent" diameter="25" strokeWidth="2" class="loader" />
                                                    </div>
                                                }
                                            </div>
                                        }
                                        @case ('audio') {
                                            <div
                                                [class.bg-brand-main-darker]="message.myMessage"
                                                [class.bg-white]="!message.myMessage"
                                                [class.dark:bg-kiwid-surface-sunken]="!message.myMessage"
                                                class="z-10 relative py-[10px] px-[8px] w-full max-h-[150px] overflow-hidden rounded-[8px] flex flex-row justify-center items-center hover:cursor-pointer"
                                                (click)="message.media.onClick()"
                                            >
                                                <k-audio-player
                                                    [variant]="message.myMessage ? 'secondary' : 'primary'"
                                                    [waves]="message.media.waves"
                                                    [url]="message.media.url"
                                                    [hour]="message.hour"
                                                />

                                                @if (message.media.isLoading) {
                                                    <div
                                                        (click)="$event.stopPropagation()"
                                                        class="w-full h-full absolute top-0 left-0 flex flex-row justify-center items-center hover:cursor-default"
                                                    >
                                                        <mat-spinner color="accent" diameter="25" strokeWidth="2" class="loader" />
                                                    </div>
                                                }
                                            </div>
                                        }
                                        @case ('raw') {
                                            <div
                                                [class.bg-brand-main-darker]="message.myMessage"
                                                [class.bg-white]="!message.myMessage"
                                                [class.dark:bg-kiwid-surface-sunken]="!message.myMessage"
                                                class="z-10 relative p-[3px] pb-6 w-full overflow-hidden text-ellipsis rounded-[8px] flex flex-row justify-center items-center hover:cursor-pointer"
                                            >
                                                <a class="flex flex-col text-ellipsis hover:cursor-pointer" (click)="message.media.onClick()">
                                                    <img
                                                        class="max-w-[128px]"
                                                        (load)="message.media.onLoad()"
                                                        src="/assets/images/chat/scanner.svg"
                                                        [alt]="message.media.title"
                                                    />

                                                    <div class="w-[128px] max-w-full text-ellipsis overflow-hidden pt-[2px]">
                                                        <span
                                                            class="px-1 truncate"
                                                            [class.text-white]="message.myMessage"
                                                            [class.text-[#7d8a91]]="!message.myMessage"
                                                            [class.dark:text-kiwid-text-main-darkest]="!message.myMessage"
                                                        >
                                                            {{ message.media.title }}
                                                        </span>
                                                    </div>
                                                </a>

                                                <div
                                                    style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0))"
                                                    class="pt-[15px] px-[10px] pb-[5px] rounded-b-[8px] pr-[10px] text-[11px] font-medium text-right text-white leading-[160%] absolute bottom-[2px] right-[2px] left-[2px] hover:cursor-pointer"
                                                >
                                                    {{ message.hour }}
                                                </div>

                                                @if (message.media.isLoading) {
                                                    <div
                                                        (click)="$event.stopPropagation()"
                                                        class="w-full h-full absolute top-0 left-0 flex flex-row justify-center items-center hover:cursor-default"
                                                    >
                                                        <mat-spinner color="accent" diameter="25" strokeWidth="2" class="loader" />
                                                    </div>
                                                }
                                            </div>
                                        }
                                    }
                                } @else {
                                    <div
                                        [class.bg-brand-main-darker]="message.myMessage && !message.isDeleted"
                                        [class.bg-white]="!message.myMessage && !message.isDeleted"
                                        [class.dark:bg-kiwid-surface-sunken]="!message.myMessage && !message.isDeleted"
                                        [class.bg-neutral-light]="message.isDeleted"
                                        class="z-10 rounded-[12px] pt-[6px] pb-[7px] px-[10px]"
                                    >
                                        <span
                                            class="font-regular text-[14px] leading-[18px] pr-2"
                                            [class.text-white]="message.myMessage && !message.isDeleted"
                                            [class.text-[#556168]]="!message.myMessage && !message.isDeleted"
                                            [class.dark:text-kiwid-text-main-darkest]="!message.myMessage && !message.isDeleted"
                                            [class.text-neutral-darker]="message.isDeleted"
                                            [class.italic]="message.isDeleted"
                                            [style.margin-right]="refContainer.clientWidth + 'px!important'"
                                        >
                                            {{ message.text }}
                                        </span>
                                    </div>

                                    <div #refContainer class="z-10 absolute bottom-[5px] right-[10px] flex items-center">
                                        @if (!message.isDeleted) {
                                            <span
                                                class="font-regular text-[11px] leading-[15px]"
                                                [class.text-brand-main-light]="message.myMessage"
                                                [class.text-[#01010173]]="!message.myMessage"
                                                [class.dark:text-kiwid-text-main-darkest]="!message.myMessage"
                                            >
                                                {{ message.hour }}
                                            </span>
                                        }
                                    </div>
                                }

                                @if (message.isLast) {
                                    @if (message.myMessage) {
                                        <svg
                                            width="12"
                                            height="14"
                                            viewBox="0 0 12 14"
                                            class="absolute bottom-[-1px] right-[-6px] z-0"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M11.1614 13.1304C7.44173 9.12273 6.28753 5.66791 6.05038 1.11758C6.02292 0.590679 5.28874 0.422516 5.05279 0.894427L0.183314 10.6334C0.0767245 10.8466 0.134722 11.1064 0.32866 11.245C3.46666 13.4867 7.80603 13.9142 10.7934 13.9865C11.2387 13.9973 11.4644 13.4569 11.1614 13.1304Z"
                                                style="fill: var(--kiwid-brand-main-darker)"
                                            />
                                        </svg>
                                    } @else {
                                        <svg
                                            width="12"
                                            height="14"
                                            viewBox="0 0 12 14"
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="absolute bottom-[-1px] left-[-6px] z-0"
                                            style="transform: scaleX(-1)"
                                        >
                                            <path
                                                d="M11.1614 13.1304C7.44173 9.12273 6.28753 5.66791 6.05038 1.11758C6.02292 0.590679 5.28874 0.422516 5.05279 0.894427L0.183314 10.6334C0.0767245 10.8466 0.134722 11.1064 0.32866 11.245C3.46666 13.4867 7.80603 13.9142 10.7934 13.9865C11.2387 13.9973 11.4644 13.4569 11.1614 13.1304Z"
                                                class="fill-white dark:fill-kiwid-surface-sunken"
                                            />
                                        </svg>
                                    }
                                }
                            </div>
                        </div>
                    }
                }
            </div>

            @if (isLoadingPage()) {
                <div class="z-999 absolute top-0 w-full p-2 flex justify-center items-center">
                    <mat-spinner diameter="25" strokeWidth="2" />
                </div>
            }

            @if (viewScrollBottom().enabled) {
                <div
                    class="absolute z-999 bottom-3 right-5 bg-brand-main-dark rounded-full overflow-hidden flex flex-col transition-all duration-300 gap-1 justify-center items-center size-[44px] cursor-pointer shadow-md"
                    (click)="isScrollBottom.set(true)"
                >
                    <mat-icon svgIcon="feather:arrow-down" class="text-white size-24" />

                    @if (!!viewScrollBottom().message) {
                        <div class="flex justify-normal items-center overflow-hidden text-ellipsis max-w-[18px]">
                            <span class="text-white truncate text-center">
                                {{ viewScrollBottom().message }}
                            </span>
                        </div>
                    }
                </div>
            }
        }
    }
</div>
